import { render } from "./AppHelpText.vue?vue&type=template&id=e3538df2&scoped=true&lang=pug"
const script = {}

import "./AppHelpText.vue?vue&type=style&index=0&id=e3538df2&lang=scss&scoped=true"

import exportComponent from "/Users/edsonfer/Documents/dev-projects/node-projects/portal-gignet-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3538df2"]])

export default __exports__